import { AfterViewInit, Component, signal, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Modal } from 'bootstrap';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatSort } from '@angular/material/sort';
import { SalaryBankExportKind } from '@/drivers/driver.model';
import { encodeURIParamsLegacy } from '@/_utils/encode-uri-params';

export interface DriverSalary {
	diets: CurrencyConversion;
	sumRates: CurrencyConversion;
	mobilityPackage: CurrencyConversion;
	sumBenefits: CurrencyConversion;
	sumDeduction: CurrencyConversion;
	payments: CurrencyConversion;
	basicSalary: CurrencyConversion;
	transfer: CurrencyConversion;
	cash: CurrencyConversion;
	leftToPay: CurrencyConversion;
	sumAll: CurrencyConversion;
}

interface CurrencyConversion {
	PLN: number;
	EUR: number;
	converted_pln: number;
	details: DriversSalaryDetails[];
}

export interface DriversSalaryDetails {
	value: number;
	currency: string;
	comment: string;
	month: string;
	name: string;
	driver: string;
}

@Component({
	selector: 'app-drivers-salary-month-list',
	templateUrl: './drivers-salary-month-list.component.html',
	styleUrls: ['./drivers-salary-month-list.component.css'],
})
export class DriversSalaryMonthListComponent extends ListComponent implements AfterViewInit {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	protected readonly SalaryBankExportKind = SalaryBankExportKind;
	protected itemsBeforeDataLoad = 6;
	protected apiUrl = 'driver/driverSummaryList';
	protected filterValue = '';
	protected drivers;
	protected month;
	filters = {
		month: null,
	};
	data;

	summaryMonth: string;
	parameters = {
		drivers: [],
		driverKinds: [],
		status: [],
		companies: [],
		dietKinds: [
			{ id: 0, name: 'Przelew' },
			{ id: 1, name: 'Gotówka' },
		],
		yesno: [
			{ id: 0, name: 'Nie' },
			{ id: 1, name: 'Tak' },
		],
	};

	materialTableKeys: string[];
	materialTable = [
		{ id: `lp`, name: `LP` },
		{ id: `driverName`, name: `Kierowca` },
		{ id: `shortName`, name: `Spółka` },
		{ id: `name`, name: `Typ` },
		{ id: `status`, name: `Status` },
		{ id: `basicSalary`, name: `Podstawa` },
		{ id: `mobilityPackage`, name: `P. Mobilności(Dieta)` },
		{ id: `sumRates`, name: `Wgl stawek` },
		{ id: `sumBenefits`, name: `Dodatki` },
		{ id: `sumDeduction`, name: `Potrącenia` },
		{ id: `transfer`, name: `Przelew` },
		{ id: `cash`, name: `Gotówka` },
		{ id: `sumAll`, name: `Suma PLN` },
		{ id: `sumEuro`, name: `Suma EUR` },
		{ id: `leftToPay`, name: `Pozostało do zapłaty` },
		{ id: `diet_name`, name: `Dieta w gotówce` },
	];

	matData = new MatTableDataSource<any>();

	readonly sum = signal<DriverSalary>(null);

	ngAfterViewInit() {
		this.matData.sort = this.sort;
	}

	protected loadBefore() {
		this.api.get('/driverKinds/', (result, error) => {
			this.parameters.driverKinds = result.data;
			this.loadData();
		});
		this.api.get('/driverStatus/', (result, error) => {
			this.parameters.status = result.data;
			this.loadData();
		});
		this.api.get('/company/', (result, error) => {
			this.parameters.companies = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result, error) => {
			this.parameters.drivers = result.data;
			this.loadData();
		});
	}

	setMonth(date: string) {
		this.summaryMonth = date;
		this.month = date + '-01';
		this.filters.month = this.month;
		this.loadData();
		this.loadSalaryMonthSummary();
	}

	protected convertData(data): void {
		this.materialTableKeys = this.materialTable.map((col) => col.id);
		data.forEach((obj) => {
			const diet = this.parameters.yesno.find((objfind) => objfind.id == obj.diet);
			obj.diet_name = diet ? diet.name : '';
			obj.sumEuro = obj.currency_value.sumAll.EUR;
		});
		this.materialTableKeys.push('action-button');
		this.matData.data = data.map((item, i) => {
			item.lp = i + 1;
			return item;
		});
		return data;
	}

	diet(exportKind: string): void {
		const data = {
			cmd: exportKind,
			month: this.month,
		};
		this.api.command(`/driver/driverSummaryList/`, data, (result, error) => {
			if (error) {
				return;
			}
		});

		new Modal(document.getElementById('diet')).show();
	}

	linkClose(): void {
		const modal = Modal.getInstance(document.getElementById('diet'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	refreshFilter(): void {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	filtersSelected(data): void {
		this.filters = data;
		this.filters.month = this.month;
		this.loadData();
		this.loadSalaryMonthSummary();
	}

	private loadSalaryMonthSummary(): void {
		const params: string = encodeURIParamsLegacy(this.api.getChecked(this.filters, this.parameters));

		this.api.get(
			`/driverSalarySummary?${params}`,
			(result: { data: DriverSalary; error: unknown; errorCode: unknown }, error) => {
				if (!result) {
					return;
				}
				this.sum.set(result.data);
			},
		);
	}
}
